<script>
    import DialogBody from "../../dialog/components/dialog-body.vue";
    import UserWizard from "./user-wizard.vue";
    import DialogHeader from "../../dialog/components/dialog-header.vue";
    import DialogBase from "../../dialog/components/dialog-base.vue";
    import TextField from "../../common/text-field.vue";
    import SelectField from "../../common/select-field.vue";
    import {translations, customerLevels} from "./data/variables";
    import DialogActionbar from "../../dialog/components/dialog-actionbar.vue";
    import API from "../../../API";
    import Loading from "../../common/loading.vue";
    import toaster from "../../common/toaster";

    export default {
        name: "user-multi-edit-dialog",
        computed: {
            levels() {
                return customerLevels;
            },
            translations() {
                return translations
            },
            title() {
                return translations.multiEditTitle.split(' - ')[0];
            },
            subTitle() {
                return translations.multiEditTitle.split(' - ')[1];
            }
        },
        components: {Loading, DialogActionbar, SelectField, TextField, DialogBase, DialogHeader, UserWizard, DialogBody},
        data() {
            return {
                showDialog: false,
                saving: false,
                names: [],
                ids: [],
                users: [],
                customerName: '',
                customerExternalId: '',
                levelValue: customerLevels[0],
                placeholderCustomerName: '',
                placeholderCustomerExternalId: '',
            }
        },
        methods: {
            show() {
                this.saving = false;
                this.showDialog = true;
            },
            hide() { this.showDialog = false; },
            handleClose() { this.hide(); },
            async handleSave() {
                this.saving = true;
                const url = '/administration/user/multi-edit-customer-info';
                const api = new API(url);

                const data = {
                    ids: this.ids,
                    level: this.levelValue,
                    customerName: this.customerName,
                    customerExternalId: this.customerExternalId,
                    placeholderCustomerName: this.placeholderCustomerName,
                    placeholderCustomerExternalId: this.placeholderCustomerExternalId
                }

                const result = await api.post(data)

                if (result.errored) {
                    this.errored = true;
                    toaster.error(translations.failedModifyUser);
                    this.saving = false;
                } else {
                    this.errored = false;
                    toaster.success(Lang.langGet("Users edited successfully."));
                    this.hide();
                }
            },
            startup(users) {
                this.names = users.map(user => `${user.first_name} ${user.last_name}`);
                this.ids = users.map(user => user.id);
                this.users = users;

                this.placeholderCustomerName = _.uniq(users.map(user => user.customer_name)).join(', ');
                this.placeholderCustomerExternalId = _.uniq(users.map(user => user.customer_external_id)).join(', ');
            }
        },
        mounted: function () {
            EaseEventBus.listen('userMultiEdit_CustomerInfo', users => {
                this.startup(users);
                this.show();
            });
        }
    }
</script>

<template>
    <dialog-base
        :maxWidth="600"
        persistent
        @close="handleClose"
        :showDialog="showDialog"
    >
        <dialog-header
            @close="handleClose"
            :title="title"
            :subTitle="subTitle"
        />
        <loading :loading="saving"/>
        <dialog-body>
            <div style="min-height: 40vh" class="d-flex flex-column align-center justify-center">
                <text-field class="ma-4 pa-2"
                    :label="translations.users"
                    :value="names.join(', ')"
                    disabled
                    textarea
                />
                <text-field class="mx-6 pa-2"
                    v-model="customerName"
                    :placeholder="placeholderCustomerName"
                    :label="translations.customerName"
                />
                <text-field class="mx-6 pa-2"
                    v-model="customerExternalId"
                    :placeholder="placeholderCustomerExternalId"
                    :label="translations.customerExternalId"
                />
                <select-field class="w-100 mx-6 pa-2"
                    v-model="levelValue"
                    :items="levels"
                    :label="translations.levels"
                />
            </div>
        </dialog-body>
        <dialog-actionbar
            :disableSave="saving"
            :processing="saving"
            :confirmIcon="saving ? 'fa-spinner-third fa-spin' : undefined"
            @close="handleClose"
            @save="handleSave"
        />
    </dialog-base>
</template>

<style scoped>

</style>
